import ReservationCardDispatcher from '../dispatcher/ReservationCardDispatcher';
import ReservationCardConstants from '../constants/ReservationCardConstants';
import DateHelper from '../../DateHelper/DateHelper';

var objectAssign = require('object-assign');
var EventEmitter = require('events').EventEmitter.prototype;

var ReservationCardStore = objectAssign({}, EventEmitter, {

  _state: {
    active_tab: 'details',
    read_only: false,
    initialized: false,
    note_count: 0,
    service_request_count: 0,
    errors: [],
    reservation_pricing_path: null,
    reservation_email_path: null,
    reservation_payments_path: null,
    reservation_housekeeping_path: null,
    reservation_history_path: null,
    reservation_save_path: null,
    reservation_segments_path: null,
    folio_items_path: null,
    payment_logs_path: null,
    reservation_open_folios_path: null,
    reservation_payments_path: null,
    reservation_charges_path: null,
    reservation_voided_charges_path: null,
    reservation_authorized_payments_path: null,
    reservation: null,
    date_format: null,
    sent_emails: [],
    scheduled_emails: [],
    messages: [],
    send_messages_path: [],
    active_tab: "details",
    transactions_active_tab: 'current_charges', 
  },

  emitChange: function() {
    this.emit(ReservationCardConstants.CHANGE_EVENT);
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.on(ReservationCardConstants.CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener: function (callback) {
    this.removeListener(ReservationCardConstants.CHANGE_EVENT, callback);
  },

  /*
  * Initializes the store merging the options
  *
  * @param {object} opts
  */
  init: function (opts) {
    objectAssign(this._state, opts)

    this._state.loading = true;

    this.loadData(opts).then(() => {
      this._state.loading = false;
      this.emitChange();
    });

  },

  refresh: function (opts) {
    var self = this;
    this._state.loading = true;

    this.loadData(opts).then(() => {
      // self._state.reservation_segment.balance_amount = 0;
      // self._state.current_minimum_stay = this.calculateMinimumStay(
      //   self._state.reservation_segment.check_in_date,
      //   self._state.reservation_segment.check_out_date
      // );
      // self._state.current_maximum_stay = this.calculateMaximumStay(
      //   self._state.reservation_segment.check_in_date,
      //   self._state.reservation_segment.check_out_date
      // );
      this._state.read_only = opts.read_only;
      // this.findExistingSegments();
      // this.assignCustomer();
      // this.parseDates();
      // this.setOriginalSegment();
      // this.setOriginalReservation();
      // this.setPaymentLog();

      // this._state.showEditRoomType = true;

      self._state.initialized = true;
      this._state.loading = false;
      this.emitChange();
    });
  },

  loadData: function(opts) {
    var endpoint = opts.endpoint
    var self = this;
    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        type: 'POST',
        url: endpoint,
        data: {
        },
      }).done(function(data) {
        if (data) {
          self._state.reservation = data.reservation
          if (self._state.date_format) {
            self._state.date_format = DateHelper.rubyToDateFNS(self._state.date_format);
          }

          if (self._state.time_format) {
            self._state.time_format = DateHelper.rubyToDateFNS(self._state.time_format);
          }

          if (self._state.reservation.start_date) {
            self._state.reservation.start_date = DateHelper.parseDateFromBackend(self._state.reservation.start_date)
          }

          if (self._state.reservation.end_date) {
            self._state.reservation.end_date = DateHelper.parseDateFromBackend(self._state.reservation.end_date)
          }

          if (self._state.reservation.balance_date) {
            self._state.reservation.balance_date = DateHelper.parseDateFromBackend(self._state.reservation.balance_date)
          }

          if (self._state.reservation.deposit_date) {
            self._state.reservation.deposit_date = DateHelper.parseDateFromBackend(self._state.reservation.deposit_date)
          }


          self._state.initialized = true;

          // this._state.reservation_segments_for_date = data.reservation_segments_for_date
          //
          resolve();
        } else {

          reject();
        };
      });
    });
    return promise;
  },

  save: function() {
    var self = this;


    var promise = new Promise(function(resolve, reject) {
      $.ajax({
        type: 'PATCH',
        url: self._state.reservation_save_path,
        data: {
          // update reservation_segment params
          reservation: self._state.reservation,

        },
      }).done(function(data) {

        if (data.errors && data.errors.length) {
          self._state.errors = []
          for (i = 0; i < data.errors.length; i++) {
            self._state.errors.push(data.errors[i])
          }
          self.emitChange();
        } else {
          if(parent && parent.refresh_data) {
            parent.refresh_data(I18n.t('updated_successfully'));
          }
          if(parent && parent.hide_modal) {
            parent.hide_modal();
          }
        }
      })
    })

  },

  getState: function() {
    return this._state
  },

});

ReservationCardStore.dispatchToken = ReservationCardDispatcher.register(function (payload) {

  switch (payload.action) {

    case ReservationCardConstants.INIT:
      ReservationCardStore.init(payload.opts);
      ReservationCardStore.emitChange();
      break;

    case ReservationCardConstants.SAVE:
      ReservationCardStore.save();
      break;

    case ReservationCardConstants.SET_ACTIVE_TAB:
      ReservationCardStore._state.active_tab = payload.tab;
      ReservationCardStore.emitChange();
      break;

    case ReservationCardConstants.SET_SUBMIT_BUTTON:
      ReservationCardStore._state.submitButton = payload.submitButton;
      ReservationCardStore.emitChange();
      break;

    case ReservationCardConstants.CHANGE_NOTES:
      ReservationCardStore._state.reservation.notes = payload.notes;
      ReservationCardStore.emitChange();
      break;

    case ReservationCardConstants.REFRESH:
      ReservationCardStore.refresh(payload.opts);
      ReservationCardStore.emitChange();
      break;

    case ReservationCardConstants.UPDATE_NOTE_COUNT:
      ReservationCardStore._state.note_count = payload.count;
      ReservationCardStore.emitChange();
      break;

    case ReservationCardConstants.UPDATE_SERVICE_REQUEST_COUNT:
      ReservationCardStore._state.service_request_count = payload.count;
      ReservationCardStore.emitChange();
      break;

    default:

  }

})

ReservationCardStore.setMaxListeners(0);

export default ReservationCardStore;
